package com.kanati.shared.event

import com.kanati.shared.ticket.TicketEntitlementDto
import kotlinx.serialization.Serializable

@Serializable
data class TicketTierDto(
    val id: String,
    val name: String,
    val priceAmount: Int,
    val capacity: Int? = null,
    val active: Boolean,
    val entitlements: List<TicketEntitlementDto> = emptyList(),
)

@Serializable
data class CreateTicketTierRequest(
    val name: String,
    val priceAmount: Int,
    val capacity: Int? = null,
    val active: Boolean = true,
    val entitlements: List<TicketEntitlementDto> = emptyList(),
)

@Serializable
data class UpdateTicketTierRequest(
    val id: String? = null,
    val name: String,
    val priceAmount: Int,
    val capacity: Int? = null,
    val replaceCapacity: Boolean = false,
    val active: Boolean = true,
    val entitlements: List<TicketEntitlementDto> = emptyList(),
)

@Serializable
data class EventDto(
    val id: String,
    val districtId: String,
    val schoolId: String = "",
    val name: String,
    val startDate: String,
    val endDate: String,
    val location: String,
    val capacity: Int? = null,
    val startingPriceAmount: Int?,
    val ticketTiers: List<TicketTierDto>,
    val active: Boolean,
    val createdAt: String,
    val updatedAt: String,
)

@Serializable
data class CreateEventRequest(
    val districtId: String,
    val schoolId: String = "",
    val name: String,
    val startDate: String,
    val endDate: String,
    val location: String,
    val capacity: Int? = null,
    val ticketTiers: List<CreateTicketTierRequest>,
)

@Serializable
data class UpdateEventRequest(
    val districtId: String,
    val schoolId: String = "",
    val name: String?,
    val startDate: String?,
    val endDate: String?,
    val location: String?,
    val capacity: Int? = null,
    val replaceCapacity: Boolean = false,
    val ticketTiers: List<UpdateTicketTierRequest>? = null,
    val active: Boolean?,
)

@Serializable
data class EventTicketTierStatsDto(
    val ticketTierId: String,
    val ticketTierName: String,
    val capacity: Int? = null,
    val soldCount: Int,
    val reservedPaperCount: Int = 0,
    val remainingCount: Int? = null,
)

@Serializable
data class EventStatsDto(
    val eventId: String,
    val capacity: Int? = null,
    val soldCount: Int,
    val reservedPaperCount: Int = 0,
    val remainingCount: Int? = null,
    val usedCount: Int,
    val ticketTierStats: List<EventTicketTierStatsDto> = emptyList(),
)
